/* -disable react/no-array-index-key */
/* -disable prefer-destructuring */
/*eslint-disable react/no-deprecated */
import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Rectangle,
  Cell,
  Text,
  LabelList,
  ReferenceLine,
} from 'recharts';
import { dotToComma } from '../../../util/helperFunctions';

import './styles.css';

const COLORS = [
  '#F8E71C',
  '#8B572A',
  '#7ED321',
  '#417505',
  '#BD10E0',
  '#9013FE',
  '#4A90E2',
  '#50E3C2',
  '#B8E986',
  '#FFFFFF',
];

class VerticalBarsByStateChart extends React.Component {
  componentWillMount() {
    const { states, selector } = this.props;

    this.data = states.map(state => {
      if (state[`${selector}`] > this.twoBiggers[0]) {
        this.twoBiggers[0] = state[`${selector}`];
      } else if (state[`${selector}`] > this.twoBiggers[1]) {
        this.twoBiggers[1] = state[`${selector}`];
      }

      return {
        name: state.initials,
        value: state[`${selector}`],
        label: [state[`${selector}`], state.percentage],
      };
    });
  }

  twoBiggers = [0, 0];
  data = null;

  _renderCustomizedLabel = props => {
    const { x, y, value } = props;

    const { sufix } = this.props;

    let formatedValue = null;
    if (!sufix) {
      formatedValue = value[0];
    } else {
      formatedValue = dotToComma(value[0]);
    }

    return (
      <g>
        <Text
          x={x + 5}
          y={y - 28}
          fill="#C0C0C0"
          textAnchor="middle"
          dominantBaseline="middle"
        >{`${formatedValue}${sufix}`}</Text>
        <Text
          x={x + 5}
          y={y - 11}
          fill="#C0C0C0"
          textAnchor="middle"
          dominantBaseline="middle"
        >{`(${dotToComma(value[1])}%)`}</Text>
      </g>
    );
  };

  render() {
    const { states } = this.props;

    return (
      <ResponsiveContainer>
        {states && (
          <BarChart
            data={this.data}
            margin={{
              top: 0,
              right: 0,
              left: 0,
              bottom: 0,
            }}
          >
            <XAxis
              type="category"
              dataKey="name"
              domain={[0, 'dataMax + 1000']}
            />
            <YAxis type="number" />
            <ReferenceLine
              y={this.twoBiggers[0]}
              stroke="#404040"
              strokeDasharray="3 3"
            />
            <ReferenceLine
              y={this.twoBiggers[1]}
              stroke="#404040"
              strokeDasharray="3 3"
            />
            <Bar
              dataKey="value"
              background={{ fill: '#202020' }}
              fill="#fff"
              barSize={10}
              shape={<Rectangle radius={[5, 5, 5, 5]} />}
            >
              {this.data.map((entry, index) => (
                <Cell key={index} fill={COLORS[index]} />
              ))}
              <LabelList
                dataKey="label"
                position="top"
                content={this._renderCustomizedLabel}
              />
            </Bar>
          </BarChart>
        )}
      </ResponsiveContainer>
    );
  }
}

VerticalBarsByStateChart.propTypes = {
  states: PropTypes.arrayOf(PropTypes.object),
};

VerticalBarsByStateChart.defaultProps = {
  states: [],
};

export default VerticalBarsByStateChart;
